export default __webpack_public_path__ + "images/valentino_baptista-59107c544e04bf7689994872ee6a85aa.png";